import { Component, Input } from '@angular/core';

@Component({
    selector: '[trace-step]',
    templateUrl: './step.component.html',
    styleUrls: ['./step.component.css'],
})
export class StepComponent {

    // data members

    @Input()
    title: string = '';

    @Input()
    titleY!: number;

    @Input()
    path: any;

    @Input()
    color: string = '';

    @Input()
    highlight: boolean = false;
}
